import React from "react";
import ReactDOM from "react-dom";

import "@fortawesome/fontawesome-free/css/all.min.css";
import "bootstrap/dist/css/bootstrap.min.css";
import "assets/scss/light-bootstrap-dashboard-pro-react.scss?v=2.0.0";
import "assets/css/demo.css";
// Loaded LAST on purpose: it corrects theme rules (e.g. disabled solid
// buttons going transparent mid-request) and only wins on source order.
import "assets/css/lusuku-overrides.css";
// Configures toasts once for the whole dashboard (severity durations,
// stacking limit, title and detail body). Views import { notify } from it.
import "./utilities/notify.js";

import axios from "axios";
import { Provider } from "react-redux";
import App from "./App";
import store from "./reducers/store";
import { BrowserRouter } from "react-router-dom";
import { GoogleMapsProvider } from "./GoogleMapsContext";
import { getActiveCountry } from "./utilities/activeCountry.js";

// ── Multi-national: stamp `x-country` on EVERY axios request ────────────────
// The central `API` instance already sets this via its request interceptor, but
// ~34 view files use raw `axios` (or secondary instances) that BYPASS that
// interceptor. Without a header, the backend defaults a super-admin to their
// HOME country (UG) — which is why switching to ZM still showed Uganda data on
// those pages. Setting the global default makes the active-country selection
// reach the backend on ALL requests. (Read at request time for the default
// instance; the switcher hard-reloads on change so this is always current.)
axios.defaults.headers.common["x-country"] = getActiveCountry();

ReactDOM.render(
  <Provider store={store}>
    <BrowserRouter>
      <GoogleMapsProvider>
        <App />
      </GoogleMapsProvider>
    </BrowserRouter>
  </Provider>,
  document.getElementById("root")
);

// ── PWA service worker (Web Push + installability) ──────────────────────────────
// Registers /service-worker.js at root scope so OS-level new-order notifications
// fire even when the dashboard tab is closed. The SW does not cache app assets
// (see public/service-worker.js), so it can't serve a stale bundle. Registration
// is best-effort and never blocks the app.
if ("serviceWorker" in navigator) {
  window.addEventListener("load", () => {
    navigator.serviceWorker
      .register(`${process.env.PUBLIC_URL || ""}/service-worker.js`, { scope: "/" })
      .catch((err) => {
        // eslint-disable-next-line no-console
        console.warn("[PWA] Service worker registration failed:", err?.message);
      });
  });
}
